import { Link, useSearchParams } from "react-router-dom";
import DashboardLayout from "../../../Layout/DashboardLayout";
import { OrderManagementTable } from "./Components/OrderManagementTable";
import { cn } from "utils";
import Button from "Components/Button";
import { PlusIcon } from "Layout/icons";
import { useState } from "react";
import { SearchBox } from "./SearchBox";
import { useDebounce } from "hooks/useDebounce";

const DEFAULT_TYPE = "all";
const orderTypes = [
  {
    label: "All Orders",
    value: DEFAULT_TYPE,
  },
  {
    label: "New orders",
    value: "Placed",
  },
  {
    label: "Processing",
    value: "Processing",
  },
  {
    label: "Shipped",
    value: "Shipped",
  },
  {
    label: "Delivered",
    value: "Delivered",
  },
  {
    label: "Cancelled",
    value: "Cancelled",
  },
];

const OrderManagement = () => {
  const [params] = useSearchParams();

  const [search, setSearch] = useState("");
  const debounceSearch = useDebounce(search);

  const ordersType = params.get("type") || DEFAULT_TYPE;

  return (
    <DashboardLayout
      title="Order Management"
      back={false}
      className="h-[92%]"
      right={
        <div className="grid gap-2 grid-cols-[2fr_1fr]">
          <SearchBox
            value={search}
            onChange={setSearch}
            placeholder="Search Order ID, Customer Name"
          />
          <div className="">
            <Link to="/order-management/create">
              <Button
                label={
                  <div className="flex items-center gap-2">
                    <PlusIcon />
                    Create New Order
                  </div>
                }
              />
            </Link>
          </div>
        </div>
      }
    >
      <div className="flex border-b border-[#F0F0F0]">
        {orderTypes.map((item) => (
          <Link
            key={item.value}
            // to={`/order-management?type=${item.value}`}
            to={{
              pathname: "/order-management",
              search: `?type=${item.value}`,
            }}
            className={cn(
              "px-5 py-6 text-primary-foreground cursor-pointer hover:bg-orange/10",
              {
                "bg-primary-light text-orange": item.value === ordersType,
              }
            )}
          >
            <div className="">{item.label}</div>
          </Link>
        ))}
      </div>

      <OrderManagementTable
        status={ordersType === DEFAULT_TYPE ? undefined : ordersType}
        search={debounceSearch}
      />
    </DashboardLayout>
  );
};

export default OrderManagement;
